import React from 'react';
import { Card } from '../ui/Card';

export function ShopTab() {
  return (
    <div className="space-y-4 p-4">
      <h2 className="text-lg font-semibold text-on-surface">Recommended Products</h2>
      <p className="text-sm text-on-surface-variant">
        The tools that support your journey.
      </p>

      <ShopCategory
        title="Electrolytes"
        description="The 222 Regimen requires sodium, potassium, and magnesium. These are the products I use."
      />

      <ShopCategory
        title="Scales"
        description="A good scale matters. Measure what you manage."
      />

      <ShopCategory
        title="Books"
        description="The science behind the protocols."
      />

      <div className="text-center text-xs text-on-surface-variant">
        <button className="text-primary hover:underline" onClick={() => {}}>
          View All Products
        </button>
      </div>
    </div>
  );
}

function ShopCategory({ title, description }: { title: string; description: string }) {
  return (
    <Card>
      <h3 className="mb-2 text-base font-semibold">{title}</h3>
      <p className="mb-4 text-sm text-on-surface-variant">{description}</p>
      <div className="rounded-lg bg-on-surface/5 p-4 text-center">
        <p className="text-sm text-on-surface-variant">Coming soon — affiliate links</p>
      </div>
    </Card>
  );
}
